import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const IndividualsFamiliesPage = () => {
  return <SanityContentPage slug='individuals-families' />
}

export default IndividualsFamiliesPage
